import React, { Component } from 'react';
import styles from './CollectionList.module.css';
import TableView from '../../components/TableView';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  fetchProducts,
  getProducts,
  addProduct,
  updateProduct,
} from '../../modules/productFamily';
import { fetchTags, getTags } from '../../modules/tags';
import { fetchScenes, getScenes } from '../../modules/scenes';
import Swatch from '../../components/Swatch';

class CollectionList extends Component {
  state = {
    sortBy: { index: 0, order: 1 },
  };

  async componentDidMount() {
    const { fetchProducts, fetchTags, fetchScenes } = this.props;
    await fetchProducts();
    await fetchTags();
    await fetchScenes();
  }

  formatProductFamilies(products) {
    const content = [];
    const { sortBy } = this.state;
    for (let i in products) {
      const product = [
        { label: products[i].name, value: products[i]._id },
        products[i].materials.join(','),
        moment(products[i].updatedAt).format('YYYY-MM-DD HH:mm:ss'),
      ];
      content.push(product);
    }

    if (sortBy) {
      content.sort((a, b) => {
        if (typeof a[sortBy.index] === 'object') {
          return sortBy.order > 0
            ? a[sortBy.index]['label'] > b[sortBy.index]['label']
              ? 1
              : -1
            : a[sortBy.index]['label'] < b[sortBy.index]['label']
            ? 1
            : -1;
        }
        return sortBy.order > 0
          ? a[sortBy.index] > b[sortBy.index]
            ? 1
            : -1
          : a[sortBy.index] < b[sortBy.index]
          ? 1
          : -1;
      });
    }

    return {
      headers: ['Collection Name', 'Material Tags', 'Last updated'],
      content,
    };
  }

  onHeaderClick = k => {
    const { sortBy } = this.state;
    if (sortBy.index === k) {
      sortBy.order *= -1;
    } else {
      sortBy.index = k;
      sortBy.order = 1;
    }
    this.setState({ sortBy });
  };

  setProduct = product => {
    const { addProduct } = this.props;
    addProduct(product);
  };

  updateProduct = async product => {
    const { updateProduct } = this.props;
    const id = product._id;
    const update = { rules: product.rules };
    const result = await updateProduct(id, update);
    if (result && result.status === 'ok') {
    }
  };

  render() {
    const { products, tags, scenes } = this.props;
    const { headers, content } = this.formatProductFamilies(products);
    return (
      <div className={styles.container}>
        <div className={styles.header}> Collections</div>
        <div className={styles.description}>
          Select a collection to edit the material tags assigned to it
        </div>
        <TableView
          tags={tags}
          includeAlphabet={true}
          headers={headers}
          data={content}
          hasChildren={true}
          rowColor="#2375C2"
          children={Swatch}
          products={products}
          scenes={scenes}
          setProduct={this.setProduct}
          updateProduct={this.updateProduct}
          onHeaderClick={this.onHeaderClick}
        />
      </div>
    );
  }
}

const stateToProps = state => ({
  products: getProducts(state),
  tags: getTags(state),
  scenes: getScenes(state),
});

export default connect(
  stateToProps,
  { fetchProducts, updateProduct, addProduct, fetchTags, fetchScenes }
)(CollectionList);



// WEBPACK FOOTER //
// ./src/containers/CollectionList/index.js